// Copy a signing link to the clipboard, with a legacy fallback.
//
// CONSUMER: internal-ui.
//
// Exists because two e-sign surfaces (the Prepare & Send result panel
// and the record's "Sent for signature" panel) hand an advisor a fresh
// signing link when the email could not go out — and a link the UI
// tells you to copy needs a button that actually copies it. The async
// clipboard API is the normal path; the textarea/execCommand fallback
// covers browsers and non-secure contexts where it is unavailable
// (same shape as AdminTeamPage's copyToClipboard).

export async function copyTextToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Fall through to the legacy path.
  }
  try {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}
